import React from 'react';

type Props = {
  children: React.ReactNode;
} & React.JSX.IntrinsicElements['div'];

export const Container = ({ children, className, ...props }: Props) => {
  return (
    <div className={className} {...props}>
      {children}
    </div>
  );
};
